import { isEmpty } from 'lodash';

export const isItDone = (data: any) => {
  const { item, applicationData = {}, stagePayload = {}, draftKey, child, parentStatus } = data;
  if (
    applicationData?.stage === 'ksaAutomatedOnboarding' ||
    applicationData?.stage === 'ksaTechFailedOnboarding' ||
    applicationData?.stage === 'ksaCompletedOnboarding' ||
    applicationData?.stage === 'ksaManualOnboarding' ||
    applicationData?.stage === 'ksaFailedOnboarding' ||
    applicationData?.stage === 'completion'
  ) {
    return true;
  }

  if (
    applicationData?.stage === 'ksaContract' &&
    item.key !== 'contract' &&
    item?.key !== 'completion'
  ) {
    return true;
  }

  if (item.key === 'services' && applicationData?.payload?.services) {
    return true;
  }
  // initialInformation is done when the backend has moved past it
  // (activeStep is now on an 'application.*' step or later)
  if (item.key === 'initialInformation') {
    const activeStepKey = stagePayload?.activeStep?.key;
    if (activeStepKey?.startsWith('application')) return true;
    // Fallback: also check thiqahFullInfo for backward compatibility
    if (applicationData?.payload?.thiqahFullInfo) return true;
    return false;
  }
  if (item.payloadKey === draftKey) {
    return false;
  }
  if (!isEmpty(applicationData?.payload?.[item?.key])) {
    return true;
  }

  if (child && parentStatus !== 'OK') {
    return false;
  }
  const stageStatus = stagePayload?.steps?.[0]?.steps?.find((ele: any) => {
    return item?.key === ele?.key;
  })?.validationState;

  return stageStatus === 'OK';
};

export const isItDisabled = (data: any) => {
  const { item = {}, applicationData = {}, stagePayload = {}, hasSteps, previousStep } = data;

  const { activeStep = {} } = stagePayload;

  // Everything is disabled for completed/terminated stages
  if (
    applicationData?.stage === 'ksaAutomatedOnboarding' ||
    applicationData?.stage === 'ksaTechFailedOnboarding' ||
    applicationData?.stage === 'ksaCompletedOnboarding' ||
    applicationData?.stage === 'ksaManualOnboarding' ||
    applicationData?.stage === 'ksaFailedOnboarding' ||
    applicationData?.stage === 'completion'
  ) {
    return true;
  }

  if (applicationData?.stage === 'ksaContract' && item.key !== 'contract') {
    return true;
  }
  if (applicationData?.stage === 'ksaContract' && item.key === 'contract') {
    return false;
  }

  // NEW FLOW:
  // Step 1 — 'services' (Select Products) is ALWAYS the entry point, never disabled
  if (item?.key === 'services') {
    return false;
  }

  // Step 2 — 'initialInformation' is only enabled AFTER products have been selected
  if (item?.key === 'initialInformation') {
    // Disabled if no services selected yet
    if (!applicationData?.payload?.services) {
      return true;
    }
    return false;
  }

  // Steps 3+ (application, contract, completion, etc.)
  // Enabled when backend's activeStep is at or past 'application.*'
  // OR fallback: thiqahFullInfo exists (backward compatibility)
  const activeStepKey = activeStep?.key;
  const hasThiqah = !!applicationData?.payload?.thiqahFullInfo;
  const isAtApplicationStep = activeStepKey?.startsWith('application');

  if (!hasThiqah && !isAtApplicationStep) {
    return true;
  }

  if (applicationData?.payload?.[item?.payloadKey]) {
    return false;
  }

  if (activeStep?.key?.includes(item?.key) && hasSteps) {
    return false;
  }
  if (activeStep?.key === item?.key) {
    return false;
  }
  if (applicationData?.payload?.[previousStep?.payloadKey]) {
    return false;
  }

  return true;
};
